import React, { useEffect, useState } from 'react'
import Layout from 'components/Layout'
import Map from 'components/Map'
import Scrollflyto from '../components/Scrollflyto/Scrollflyto'
import scrollflyto from '../constants/scrollflyto'
import styled from 'style'
import Sidebar from 'components/Sidebar'
import { Box, Flex } from 'components/Grid'


const sources = {
  dreieck: {
    type: 'geojson',
    data: {
      type: 'Polygon',
      coordinates: [[[12.11718, 46.57388],[12.11907, 46.57454],[12.11976, 46.57428],[12.12051, 46.57157],[12.11909, 46.57016],
        [12.11866, 46.56992]],

        [[12.11036, 46.52214],[12.11212, 46.52410],[12.11291, 46.52433],[12.11356, 46.52378],[12.11361, 46.52312]],


        [[12.15052, 46.50643],[12.15005, 46.50728],[12.15205, 46.50787],[12.15595, 46.50811],[12.15800, 46.50581],[12.15776, 46.50467]]],
      //  coordinates: [[[12.3397707, 45.505061], [8.7255307, 45.6300625], [12.14, 46.54]]],
    },
  }
,
}



const layers = [
    {
    id: '1',
    source: 'dreieck',
    type: 'fill',
    paint: {
      'fill-color': 'red',
      'fill-opacity': 0.35,
    },
  },
]




const MapPage = () => {
  const [scrollPosition, setSrollPosition] = useState(0)
  const handleScroll = () => {
    var activeName = scrollflyto[0].title
    for (var i = 0; i < scrollflyto.length; i++) {
      if (isElementOnScreen(scrollflyto[i].title)) {
        setActiveChapter(scrollflyto[i].title, i)
        break
      }
    }
    function setActiveChapter(chapterName, i) {
      if (chapterName === activeName) return

      map.flyTo(scrollflyto[i])

      document.getElementById(chapterName).setAttribute('class', 'active')
      document.getElementById(activeName).setAttribute('class', '')

      activeName = chapterName
    }

    function isElementOnScreen(id) {
      var element = document.getElementById(id)
      var bounds = element.getBoundingClientRect()
      return bounds.top < window.innerHeight && bounds.bottom > 0
    }
    const position = window.pageYOffset
    setSrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Layout title="Milano-Cortina 2026">
      <Wrapper>
        <Sidebar>
          <Box p="1rem">
            <Scrollflyto scrollflyto={scrollflyto} />
          </Box>
        </Sidebar>
        <Map styles={['streets-v11']} sources={sources} layers={layers}/>
      </Wrapper>
    </Layout>
  )
}

// this wrapper needs to be 100% to force map and sidebar to fill the full space
const Wrapper = styled(Flex)`
  height: 100%;
`

export default MapPage
